import { makeStyles } from '@material-ui/core';
import { colors } from 'theme';
import {
  FILTER_MISE_COHERENCE_CENTRE_TRI,
  FILTER_MISE_COHERENCE_DIFFERENTE,
  FILTER_MISE_COHERENCE_REPRENEUR,
  FILTER_MISE_COHERENCE_TOUS,
} from './constants';

const filterMiseCoherenceElementSelectedStyle = (borderColor: string) => {
  return {
    border: `2px solid ${borderColor}`,
    borderRadius: '6px',
  };
};

const filterMiseCoherenceElementStyle = (backgroundColor: string) => {
  return {
    padding: '10px',
    fontWeight: 400,
    fontFamily: '"Gill Sans", "Helvetica", "Arial", sans-serif',
    color: colors.white,
    border: 'none',
    borderRadius: '4px',
    margin: '2px',
    backgroundColor: `${backgroundColor}`,

    '&:hover': {
      backgroundColor: `${backgroundColor}`,
    },
  };
};

export const colorFilterMiseEnCoherence = {
  [FILTER_MISE_COHERENCE_TOUS]: colors.black,
  [FILTER_MISE_COHERENCE_CENTRE_TRI]: '#B5C974',
  [FILTER_MISE_COHERENCE_REPRENEUR]: '#CFC3FA',
  [FILTER_MISE_COHERENCE_DIFFERENTE]: '#EAC579',
};

export const useStyles = makeStyles({
  fieldLine: {
    marginTop: 8,
    margin: '1vw',
    display: 'block',

    '& span': {
      fontSize: 18,
      margin: 5,
    },
  },
  datePicker: {
    '& > div': {
      marginLeft: '25px',
      width: 150,
    },
    '& label': {
      color: '#949FAC',
    },
    '&:last-of-type > div': {
      marginRight: '25px',
    },
  },
  submitButton: {
    marginTop: 24,
  },
  searchButton: {
    fontSize: 14,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
  },
  searchButtonIcon: {
    marginLeft: '10px',
    width: 17,
    height: 17,
  },
  textField: {
    '& fieldset': {
      borderColor: colors.neutralGray,
    },
  },
  autocomplete: {
    width: 250,
    display: 'inline-block',
  },
  autocompleteControls: {
    top: '2px',
  },
  switch: {
    textAlign: 'right',
    color: colors.inputGrey,
    width: '20%',
  },
  containerBottom: {
    display: 'flex',
    flexDirection: 'row',
  },
  filterMiseCoherence: {
    paddingLeft: '1vw',
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
    alignItems: 'center',
    width: '80%',
  },
  filterMiseCoherenceElementFirst: {
    textTransform: 'none',
    ...filterMiseCoherenceElementStyle(colorFilterMiseEnCoherence[FILTER_MISE_COHERENCE_TOUS]),
  },
  filterMiseCoherenceElementSecond: {
    textTransform: 'none',
    ...filterMiseCoherenceElementStyle(colorFilterMiseEnCoherence[FILTER_MISE_COHERENCE_CENTRE_TRI]),
  },
  filterMiseCoherenceElementThird: {
    textTransform: 'none',
    ...filterMiseCoherenceElementStyle(colorFilterMiseEnCoherence[FILTER_MISE_COHERENCE_REPRENEUR]),
  },
  filterMiseCoherenceElementFourth: {
    textTransform: 'none',
    ...filterMiseCoherenceElementStyle(colorFilterMiseEnCoherence[FILTER_MISE_COHERENCE_DIFFERENTE]),
  },
  filterMiseCoherenceElementSelectedFirst: {
    ...filterMiseCoherenceElementSelectedStyle(colorFilterMiseEnCoherence[FILTER_MISE_COHERENCE_TOUS]),
  },
  filterMiseCoherenceElementSelectedSecond: {
    ...filterMiseCoherenceElementSelectedStyle(colorFilterMiseEnCoherence[FILTER_MISE_COHERENCE_CENTRE_TRI]),
  },
  filterMiseCoherenceElementSelectedThird: {
    ...filterMiseCoherenceElementSelectedStyle(colorFilterMiseEnCoherence[FILTER_MISE_COHERENCE_REPRENEUR]),
  },
  filterMiseCoherenceElementSelectedFourth: {
    ...filterMiseCoherenceElementSelectedStyle(colorFilterMiseEnCoherence[FILTER_MISE_COHERENCE_DIFFERENTE]),
  },
});
